import React from 'react';
import MaskedTextField from './MaskedTextField';
import OutlinedTextField from './OutlinedTextField';
import constants from '../constants';

type TaxIdType =
  | ''
  | typeof constants.TAX_ID_TYPE_BUSINESS_INDIVIDUAL
  | typeof constants.TAX_ID_TYPE_MEMBER_SSN
  | typeof constants.TAX_ID_TYPE_MEMBER_ITIN
  | typeof constants.TAX_ID_TYPE_BUSINESS_COMPANY
  | typeof constants.TAX_ID_TYPE_MEMBER_EMPLOYEE
  | typeof constants.TAX_ID_TYPE_MEMBER_NONE;

interface TaxIdFieldProps {
  id: string;
  value: string;
  type: TaxIdType;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isClearable?: boolean;
  setValue?: (value: string) => void;
  [key: string]: any;
}

interface MaskAndHintFormatType {
  mask?: string;
  hint: string;
}
function getFormat(type: TaxIdType): MaskAndHintFormatType {
  if (
    [constants.TAX_ID_TYPE_BUSINESS_INDIVIDUAL, constants.TAX_ID_TYPE_MEMBER_SSN].includes(type)
  ) {
    return {
      mask: '###-##-####',
      hint: 'XXX-XX-XXXX',
    };
  }
  if (type === constants.TAX_ID_TYPE_MEMBER_ITIN) {
    return {
      mask: '###-##-####',
      hint: '9XX-7X-XXXX',
    };
  }
  if (type === constants.TAX_ID_TYPE_BUSINESS_COMPANY) {
    return {
      mask: '##-#######',
      hint: 'XX-XXXXXXX',
    };
  }
  return { mask: undefined, hint: '' };
}

function TaxIdField({
  id,
  value,
  type,
  onChange,
  label,
  isClearable = true,
  setValue,
  ...other
}: TaxIdFieldProps) {
  if ([constants.TAX_ID_TYPE_MEMBER_EMPLOYEE, constants.TAX_ID_TYPE_MEMBER_NONE].includes(type)) {
    return (
      <OutlinedTextField
        id={id}
        placeholder=""
        value={value}
        onChange={onChange}
        label={label}
        isClearable={isClearable}
        setValue={setValue}
        {...other}
      />
    );
  }

  const { mask, hint } = getFormat(type);
  return (
    <MaskedTextField
      id={id}
      placeholder={hint}
      format={mask}
      value={value}
      onChange={onChange}
      label={label}
      isClearable={isClearable}
      setValue={setValue}
      {...other}
    />
  );
}

export default TaxIdField;
